/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'AdminPipesEditor';
